var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7119 8.4596L17.4124 0.837891H15.8243L10.0078 7.45546L5.3599 0.837891H0L7.02742 10.8459L0 18.8379H1.58812L7.73149 11.8487L12.6401 18.8379H18L10.7119 8.4596ZM8.53746 10.9333L7.82545 9.93689L2.15984 2.00789H4.59893L9.17006 8.40689L9.88207 9.40332L15.8256 17.7219H13.3865L8.53746 10.9333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2fd0e23381896ebda7668211f57fd38f.svg";
export { ForwardRef as ReactComponent };